<template>
  <div
    :id="id"
    class="roomie-tooltip"
    :class="setClasses"
    :style="{ top, left, right, bottom }">
    <div class="roomie-tooltip__info">
      <div>
        <p
          v-if="variant !== 'definition'"
          class="roomie-tooltip__title">
          {{ title }}
        </p>
      </div>
      <div class="roomie-tooltip__content">
        <div class="roomie-tooltip__description">
          <slot name="description" />
        </div>
      </div>
      <div
        v-if="ctaText"
        class="roomie-tooltip__cta">
        <RoomieButton
          v-if="!ctaUrl"
          id="roomie-tooltip-button"
          variant="ghost"
          size="sm"
          class="roomie-tooltip__cta-button"
          @click="closeTooltip">
          {{ ctaText }}
        </RoomieButton>

        <RoomieButtonLink
          v-if="ctaUrl"
          id="roomie-tooltip-button"
          size="sm"
          :url="ctaUrl"
          class="roomie-tooltip__cta-button"
          target-type="_blank"
          variant="ghost">
          {{ ctaText }}
        </RoomieButtonLink>
      </div>
    </div>

    <RoomieNavigationButton
      v-if="variant !== 'definition'"
      id="roomie-navigation-button-tooltip"
      size="sm"
      variant="ghost"
      class="roomie-tooltip__button"
      @click="closeTooltip">
      <CloseIcon :style="{ fill: '#fff' }" />
    </RoomieNavigationButton>

    <div
      class="roomie-tooltip__indicator"
      :class="setIndicatorClasses"
      :style="{ 'top' : indicatorTop, 'left' : indicatorLeft, 'right' : indicatorRight, 'bottom' : indicatorBottom }" />
  </div>
</template>

<script>
import RoomieNavigationButton from '../RoomieNavigationButton/index.vue'
import RoomieButton from '../RoomieButton/index.vue'
import RoomieButtonLink from '../RoomieButtonLink/index.vue'
import CloseIcon from '../../assets/icons/close.svg'

export { VARIANT } from './utils'

export default {
  name: 'RoomieTooltip',
  components: {
    RoomieNavigationButton,
    CloseIcon,
    RoomieButton,
    RoomieButtonLink
  },
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    variant: {
      type: String,
      default: 'message',
      validator: (value) => ['message', 'interactive', 'definition'].includes(value),
      required: true
    },
    isVisible: {
      type: Boolean,
      default: false,
      required: false
    },
    ctaText: {
      type: String,
      default: ''
    },
    ctaUrl: {
      type: String,
      default: ''
    },
    indicatorPlacement: {
      type: String,
      default: 'top left',
      required: false
    },
    top: {
      type: String,
      default: ''
    },
    left: {
      type: String,
      default: ''
    },
    right: {
      type: String,
      default: ''
    },
    bottom: {
      type: String,
      default: ''
    },
    indicatorTop: {
      type: String,
      default: ''
    },
    indicatorLeft: {
      type: String,
      default: ''
    },
    indicatorRight: {
      type: String,
      default: ''
    },
    indicatorBottom: {
      type: String,
      default: ''
    }
  },
  computed: {
    setClasses() {
      return {
        'non-visible': !this.isVisible,
        'roomie-tooltip--message': this.variant === 'message',
        'roomie-tooltip--interactive': this.variant === 'interactive',
        'roomie-tooltip--definition': this.variant === 'definition',
      }
    },
    setIndicatorClasses() {
      return this.indicatorPlacement.split(' ').join('-')
    }
  },
  methods: {
    closeTooltip() {
      this.$emit('tooltip-closed')
    },
  }
}
</script>

<style src='./_index.scss' lang='scss'/>
